import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Link, Td, Tr } from '@chakra-ui/react';
import { formatDataTestId } from '@whitbread-eos/utils';
import { ChevronDown, ChevronUp } from '../../assets/icons';
import { cardRowStyle, cardWrapperStyle, linkStyles, resultRowCellStyle, resultRowCellRedesignStyle } from './';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function TableListRow(_ref) {
  var _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
    dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? '' : _ref$dataTestIdPrefix,
    columns = _ref.columns,
    row = _ref.row,
    rowIndex = _ref.rowIndex,
    isExpandable = _ref.isExpandable,
    expandBtnText = _ref.expandBtnText,
    collapseBtnText = _ref.collapseBtnText,
    screenSize = _ref.screenSize,
    isExpanded = _ref.isExpanded,
    onExpand = _ref.onExpand,
    renderExpandedContent = _ref.renderExpandedContent,
    rowStyles = _ref.rowStyles,
    rowHoverStyles = _ref.rowHoverStyles,
    handleRowClicked = _ref.handleRowClicked,
    isBookingHistoryRedesign = _ref.isBookingHistoryRedesign;
  var colSpan = screenSize !== null && screenSize !== void 0 && screenSize.isLessThanSm ? columns.length - columns.filter(col => !!(col !== null && col !== void 0 && col.hideOnMobile)).length + 1 : columns.length + 1;
  var rowCellStyle = isBookingHistoryRedesign ? resultRowCellRedesignStyle(isExpanded) : resultRowCellStyle(isExpanded);
  var displayExpandedValue = (expanded, collapsed) => {
    return isExpanded ? expanded : collapsed;
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(Tr, {
      tabIndex: 0,
      "data-testid": formatDataTestId(dataTestIdPrefix, "Table-Row-".concat(rowIndex)),
      onClick: isBookingHistoryRedesign ? () => onExpand(rowIndex, isExpanded) : () => handleRowClicked && handleRowClicked(row),
      _hover: rowHoverStyles !== null && rowHoverStyles !== void 0 ? rowHoverStyles : {},
      onKeyDown: e => {
        if (e.key === 'Enter' || e.key === ' ') {
          if (isBookingHistoryRedesign) {
            onExpand(rowIndex, isExpanded);
          } else if (handleRowClicked) {
            handleRowClicked(row);
          }
        }
      },
      "aria-label": displayExpandedValue('Collapse row', 'Expand row'),
      children: [columns.map((column, colIndex) => {
        var _row$column$key;
        return screenSize !== null && screenSize !== void 0 && screenSize.isLessThanSm && column !== null && column !== void 0 && column.hideOnMobile ? null : _jsx(Td, _objectSpread(_objectSpread({
          "data-testid": formatDataTestId(dataTestIdPrefix, "Table-Cell-".concat(rowIndex, "-").concat(colIndex))
        }, _objectSpread(_objectSpread({}, rowCellStyle), rowStyles)), {}, {
          width: column.width,
          children: column !== null && column !== void 0 && column.render ? column.render(row, rowIndex, {
            isExpanded,
            onExpand
          }) : (_row$column$key = row[column === null || column === void 0 ? void 0 : column.key]) !== null && _row$column$key !== void 0 ? _row$column$key : ''
        }), column.key);
      }), isExpandable && !isBookingHistoryRedesign && _jsx(Td, _objectSpread(_objectSpread({
        "data-testid": formatDataTestId(dataTestIdPrefix, "Table-Cell-".concat(rowIndex, "-").concat(displayExpandedValue('expanded', 'collapsed')))
      }, _objectSpread(_objectSpread({}, rowCellStyle), rowStyles)), {}, {
        children: _jsxs(Link, _objectSpread(_objectSpread({}, linkStyles), {}, {
          "data-testid": formatDataTestId(dataTestIdPrefix, "Table-Cell-".concat(rowIndex, "-").concat(displayExpandedValue('collapse', 'expand'))),
          onClick: () => onExpand(rowIndex, isExpanded),
          children: [!isBookingHistoryRedesign && displayExpandedValue(collapseBtnText, expandBtnText), _jsx(Box, {
            ml: "xmd",
            children: displayExpandedValue(_jsx(ChevronUp, {
              color: "var(--chakra-colors-btnSecondaryEnabled)"
            }), _jsx(ChevronDown, {
              color: "var(--chakra-colors-btnSecondaryEnabled)"
            }))
          })]
        }))
      }), 'expand')]
    }, rowIndex), isExpandable && isExpanded && _jsx(Tr, {
      "data-testid": formatDataTestId(dataTestIdPrefix, "Table-Row-expanded"),
      children: _jsx(Td, _objectSpread(_objectSpread({
        colSpan: colSpan
      }, cardRowStyle), {}, {
        "data-testid": formatDataTestId(dataTestIdPrefix, "Table-Row-expanded-card"),
        children: _jsx(Box, _objectSpread(_objectSpread({}, cardWrapperStyle), {}, {
          children: renderExpandedContent === null || renderExpandedContent === void 0 ? void 0 : renderExpandedContent(row)
        }))
      }))
    })]
  });
}